import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TwitterShareButton,
} from 'react-share';
import absoluteUrl from 'next-absolute-url';
import { Facebook, Twitter, LinkedIn, WhatsApp } from '@material-ui/icons';

import Layout from '/layout/Layout';

import { getEvent } from '/redux/events/actions';
import Separator from '/components/ui/Separator';
import DetailCardEvent from '/components/events/DetailCardEvent';
import AttachedFiles from '/components/events/AttachedFiles';
import EventDetails from '/components/events/EventDetails';

const Event = () => {
  const [URL, setURL] = useState('');
  const isIntranetPending = useSelector(
    (state) => state.user.isIntranetLoading
  );
  const isEventsPending = useSelector((state) => state.events.isLoadingEvents);
  const focusedEvent = useSelector((state) => state.events.focusedEvent);

  const router = useRouter();
  const dispatch = useDispatch();
  const { id } = router.query;

  useEffect(() => {
    (async () => {
      if ((!focusedEvent && id) || focusedEvent?.id !== id) {
        await dispatch(getEvent(id));
      }
    })();
  }, [id]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { origin } = absoluteUrl();
      setURL(`${origin}/event/${id}`);
    }
  }, []);

  return (
    <Layout link="acceder" isLoading={isIntranetPending || isEventsPending}>
      {focusedEvent && !isEventsPending && (
        <div className="c-event">
          <Separator color="brown">
            {`
            ${format(new Date(focusedEvent.initDate), 'dd LLLL - hh:mm', {
              locale: es,
            })}h`}
          </Separator>
          <DetailCardEvent event={focusedEvent} />
          <div className="c-event__margin-container">
            <div className="c-event__attached-container">
              <AttachedFiles attachedFiles={focusedEvent.attachedFiles} />
            </div>
            <div className="c-event__share">
              <span className="c-event__share-title">
                Compártelo en tus redes
              </span>
              <div className="c-event__share-buttons">
                <FacebookShareButton
                  quote={`${focusedEvent.title} | Agenda Virtual Els Ports`}
                  url={URL}
                  hashtags={focusedEvent?.categories?.map(
                    (cat) => cat.category
                  )}>
                  <Facebook style={{ color: '#C9C2B3' }} />
                </FacebookShareButton>
                <LinkedinShareButton
                  title={`${focusedEvent.title} | Agenda Virtual Els Ports`}
                  description={focusedEvent.description}
                  source={URL}
                  url={URL}>
                  <LinkedIn style={{ color: '#C9C2B3' }} />
                </LinkedinShareButton>
                <WhatsappShareButton
                  title={`${focusedEvent.title} | Agenda Virtual Els Ports`}
                  url={URL}>
                  <WhatsApp style={{ color: '#C9C2B3' }} />
                </WhatsappShareButton>
                <TwitterShareButton
                  title={`${focusedEvent.title} | Agenda Virtual Els Ports`}
                  hashtags={focusedEvent?.categories?.map(
                    (cat) => cat.category
                  )}
                  url={URL}>
                  <Twitter style={{ color: '#C9C2B3' }} />
                </TwitterShareButton>
              </div>
            </div>
          </div>
          <EventDetails {...focusedEvent} />
        </div>
      )}
    </Layout>
  );
};

export default Event;
